// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emailIcon svg[data-v-18707cac] {\n  fill: #1A7BEE;\n  color: white;\n}\n.emailIcon svg[data-v-18707cac]:hover {\n  fill: #094C8B;\n  color: white;\n}\n.documentIcons svg[data-v-18707cac] {\n  fill: white;\n  color: #1A7BEE;\n}\n.documentIcons svg[data-v-18707cac]:hover {\n  fill: white;\n  color: #094C8B;\n}", ""]);
// Exports
module.exports = exports;
